import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { removeSwapTradeCaptureQueue } from '@/store/swap/swapTradeCaptureQueue.ts';
import { removeTile } from '@/store/tiles/slice.ts';

/**
 * clean up tile's associated PQueue from the registry
 */
export const registerSwapTradeCaptureQueueCleanupListener = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: removeTile,
    effect: (action) => {
      const tileId = action.payload;

      removeSwapTradeCaptureQueue(tileId);
    },
  });
};
